import {Component, OnInit, Input, OnDestroy, ChangeDetectionStrategy, inject} from '@angular/core';
import { AuthTokenStore } from '../../services/auth-token/auth-token.store';
import {NavigationExtras, Router} from '@angular/router';
import {Events} from '../../services/events/events.service';
import {IonButton} from "@ionic/angular";
import {Subscription} from "rxjs";
import {RealityCheckService} from "../../services/reality-check/reality-check.service";
import {ApiService} from "../../services/api/api.service";
import OneSignal from '@onesignal/capacitor-plugin';
import {PusherService} from "../../services/pusher/pusher.service";
import {TokenService} from "../../services/token/token.service";

@Component({
  changeDetection: ChangeDetectionStrategy.Eager,
  selector: 'app-reality-check',
  templateUrl: './reality-check.component.html',
  styleUrls: ['./reality-check.component.scss'],
  standalone: true,
  imports: [
    IonButton
  ]
})
export class RealityCheckComponent implements OnInit, OnDestroy {
  private readonly authTokenStore = inject(AuthTokenStore);
  private sub?: Subscription;
  showDialog = false;
  noteToSelf: string = '';
  constructor(
    public api: ApiService,
    public pusherServ:PusherService,
    public events: Events,
    private realityCheckService: RealityCheckService,
    public tokenService: TokenService,
    private router: Router
  ) {
    // events.subscribe('realitycheck:changed', (noteToSelf) => {
    //   console.log('3434xx this realitycheck:changed: ', this.pageName);
    //   // console.log('3434xx Active realitycheck:changed: ', this.app.getActiveNav().getActive().name);
    //
    //   console.log('this.router.url', this.router.url.split('?')[0], this.pageName);
    //   if (this.router.url.split('?')[0] === this.pageName) {
    //     this.showDialog = true;
    //     this.noteToSelf = noteToSelf;
    //     console.log('3434xx realitycheck:changed: ', this.pageName);
    //   }
    // });
  }

  ngOnInit() {
    this.sub = this.realityCheckService.trigger$.subscribe(note => {
        this.showDialog = true;
        this.noteToSelf = note;
    });
  }

  ngOnDestroy() {
    this.sub?.unsubscribe();
  }


  clearUserSessionToken(){
    const userSessionToken:any = this.authTokenStore.getToken()
    try {
      this.api.userDetails(userSessionToken).subscribe(userDetail => {
        // console.log('userDetail', userDetail);
        OneSignal.logout();
        // this.app.getRootNav().setRoot('WelcomePage');
        //AMPLITUDE
        this.pusherServ.deInitChannels();
        this.tokenService.clearAllExcept();
        this.closeDialog();
        this.realityCheckService.stop();
        this.api.logout(userSessionToken).subscribe(res => {
          console.log(7777);
          this.router.navigate(['welcome']);
          // window.location.reload()
          console.log('res', res);
        })
      }, (error) => {

      });
    }finally {
    }
  }

  closeDialog(){
    this.showDialog = false;
  }

  openMyaccount() {
    this.showDialog = false;
    this.router.navigate(['/tabs/myaccount']);
  }


}
